// extracted by mini-css-extract-plugin
export default {"menuItemWrapper":"MenuItemWrapper_menuItemWrapper__U1fel","active":"MenuItemWrapper_active__ha7o2"};